import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import Styles from './styles';
function Tile(props) {
    const { onClicked, option } = props;
    const { Text, Image } = option;
    return (_jsxs(Styles.Element, { onClick: () => onClicked(option), children: [Image && _jsx(Styles.Img, { src: Image }), _jsx(Styles.Title, { children: Text })] }));
}
export default Tile;
